import { ListItemIcon, ListItemIconProps } from '@mui/material';

const ListItemIconWrapper: React.FC<ListItemIconProps> = (props) => <ListItemIcon {...props} />;

export default ListItemIconWrapper;
